import React from 'react';
// import useAxios from 'axios-hooks';
import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';

import { short } from '../../common/formatting/date';

const ClaimRow = ({ claim }) => {
	// const providers = [];
	// const [{ data: careteamData, /* loading: careteamLoading, error: careteamError */ }] = useAxios({
	// 	url: `/claims/${claim.id}/claim_careteams`,
	// 	method: 'GET',
	// });
	// const [{ data: diagnosisData, loading: diagnosisLoading, /* error: diagnosisError */ }] = useAxios({
	// 	url: `/claims/${claim.id}/claim_diagnosis`,
	// 	method: 'GET',
	// });

	// if (claim.providers) {
	// 	try {
	// 		providers.push(...JSON.parse(claim.providers));
	// 	} catch (e) {
	// 		// console.log(e)
	// 	}
	// } else if (careteamData && Array.isArray(careteamData)) {
	// 	providers.push(...careteamData);
	// }

	return (
		<tr key={`${claim.id}`}>
			<td>{claim.visit_type}</td>
			<td>
				{claim.organization}
				{!isEmpty(claim.organization) && !isEmpty(claim.place_of_service_display) && (
					<br />
				)}
				{claim.place_of_service_display}
			</td>
			<td>{claim.procedure_display}</td>
			{/* <td>
				{providers.length > 0 && (
					providers.map(({ provider, name, type }) => (
						provider ? provider : `${name}, ${type}`
					)).join('\n')
				)}
			</td> */}
			<td>{short(claim.date_start, true)}</td>
			<td>{short(claim.date_end, true)}</td>
			<td>{claim.data_source}</td>
			<td>{short(claim.update_dttm, true)}</td>
		</tr>
	);
};

ClaimRow.propTypes = {
	claim: PropTypes.object
};

export default ClaimRow;
